import React    from "react"
import LineBase from "./line_base"

// Components
import Buttons from "./shared/buttons"

// Helpers
import { lineCalculations, formatNumber, lineNameFor } from "../helpers"

const resetAttributes = [
  "ref_product_distrib",
  "discount",
  "purchase_price",
  "vat_rate_id",
  "product_id",
  "is_option"
]

export default class SubTotal extends LineBase {

  onChange(field) {
    return (e) => {
      e.preventDefault()
      const { index, qline } = this.props
      const { replaceLine  } = this.props.buttonProps

      let value = e.target.value
      
      if (field === "quantity") {
        value = value === "" ? "" : parseFloat(value)
      }

      replaceLine({...qline, [field]: value}, index)
    }
  }

  render() {
    const { index, qline, showCode, buttonProps } = this.props

    const calculations = lineCalculations(qline)
    return(
      <React.Fragment>
        {
          qline.active
          ? <div className="quotes--form-qline-container">
              <div className="text-input d-flex mb-2">
                <div className="w-90">
                  <label>{I18n.t("quotes.new.description")}</label>
                  <input
                    className="form-control"
                    value={qline.description || ""}
                    onChange={this.onChange("description")}
                    name={lineNameFor("description", index)}
                  />
                </div>

                <div className="w-15 ml-2">
                  <label required>{I18n.t("quotes.new.quantity")}</label>
                  <input
                    className="form-control"
                    type="number"
                    step=".1"
                    min="0"
                    onChange={this.onChange("quantity")}
                    name={lineNameFor("quantity", index)}
                    value={qline.quantity || ""}
                  />
                </div>
              </div>

              <div className="quotes--form-calculations d-flex w-5 a-i-center j-c-center">
                {qline.unit}
              </div>

              <div className="quotes--form-calculations d-flex w-15 a-i-center j-c-center">
                {formatNumber(calculations.total)}
              </div>

              <Buttons
                index={index}
                qline={qline}
                buttonProps={buttonProps}
              />
            </div>
          : <div
              className="quotes--form-pointer quotes--form-table-row sub-total"
              onClick={this.activate}
            >
              { showCode ? <div className="code-column"></div> : "" }

              <div className="description-column">
                {qline.description}
              </div>

              { qline.quantity > 1 &&
                <>
                  <div className="price-column">
                    {formatNumber(qline.unit_price)}
                  </div>

                  <div className="amount-column">
                    {formatNumber(qline.quantity)}
                  </div>

                  <div className="unit-column">
                    {qline.unit}
                  </div>

                  <div className="vat-column"/>
                </>
              }

              <div className="total-column">
                {formatNumber(calculations.total)}
              </div>

              <Buttons
                index={index}
                qline={qline}
                buttonProps={buttonProps}
              />

              <input
                type="hidden"
                name={lineNameFor("description", index)}
                defaultValue={qline.description}
              />

              <input
                type="hidden"
                name={lineNameFor("quantity", index)}
                defaultValue={qline.quantity || "1"}
              />

              <input
                type="hidden"
                name={lineNameFor("unit", index)}
                defaultValue={qline.unit || ""}
              />
            </div>
        }

        <input
          type="hidden"
          name={lineNameFor("id", index)}
          defaultValue={qline.id}
        />

        <input
          type="hidden"
          name={lineNameFor("order", index)}
          defaultValue={index + 1}
        />

        <input
          type="hidden"
          name={lineNameFor("unit_price", index)}
          defaultValue={qline.unit_price}
        />

        <input
          type="hidden"
          name={lineNameFor("is_subtotal", index)}
          defaultValue="1"
        />

        {
          resetAttributes.map((attribute, resetIndex) =>
            <input
              key={resetIndex}
              type="hidden"
              name={lineNameFor(attribute, index)}
              defaultValue=""
            />
          )
        }
      </React.Fragment>
    )
  }
}
